import { defineStore } from 'pinia'
import { ref } from 'vue';
import { getDiskInfo } from '../api';

export const useDiskStore = defineStore('disk', {
  state: () => ({
    diskInfo: {},
  }),
  actions: {
    async getDiskInfo(): Promise<any> {
      try {
        const res = await getDiskInfo();
        this.diskInfo = res;
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
  },
  getters: {
    getDiskInfoData(state): any {
      return state.diskInfo;
    }
  },
});